export default __webpack_public_path__ + "407367ac6f475aea62782b050ebf426b.ttf";